<template>
  <div class="form-group ew-client-select">
    <label v-if="label" :for="id">{{ label }}</label>
    <div class="position-relative">
      <input type="text" :id="id" class="form-control ew-client-select__input" autocomplete="off"
        :value="open ? search : selectedLabel" placeholder="Buscar cliente o usuario..."
        @focus="onFocus" @blur="onBlur" @input="onInput($event.target.value)" @keydown.esc="close"
        v-b-tooltip.hover.top="'Busca y filtra las estadísticas por cliente o usuario específico'" />
      <i class="bi bi-search text-muted ew-client-select__search-icon"></i>
      <div v-if="loading" class="spinner-border spinner-border-sm text-muted ew-client-select__spinner"
        role="status"></div>
      <i v-else class="bi bi-chevron-down text-muted ew-client-select__caret"></i>

      <div v-if="open" class="list-group position-absolute w-100 mt-1 shadow-sm ew-client-select__list"
        @scroll="onScroll">
        <button type="button" class="list-group-item list-group-item-action"
          :class="{ active: value === 'all' }" @mousedown.prevent="selectOption('all', 'Todos')">
          Todos
        </button>
        <button type="button" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
          v-for="o in options" :key="o.value" :class="{ active: value === o.value }"
          @mousedown.prevent="selectOption(o.value, o.label)">
          <span>{{ o.label }}</span>
          <span class="badge badge-light" v-if="o.badge">{{ o.badge }}</span>
        </button>
        <div v-if="!loading && !options.length" class="list-group-item text-muted small">Sin resultados</div>
        <div v-if="loadingMore" class="list-group-item text-center text-muted small">
          <i class="bi bi-hourglass-split mr-1"></i>Cargando más...
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClientSelect',
  props: {
    value: { type: String, default: 'all' },
    selectedLabel: { type: String, default: 'Todos' },
    options: { type: Array, default: () => [] }, // [{ value, label, badge }]
    loading: { type: Boolean, default: false },
    loadingMore: { type: Boolean, default: false },
    label: { type: String, default: '' },
    id: { type: String, default: '' },
  },
  data() {
    return {
      open: false,
      search: '',
    };
  },
  methods: {
    onFocus() {
      this.open = true;
      this.search = '';
      this.$emit('search', '');
    },
    onBlur() {
      setTimeout(() => { this.open = false; }, 150);
    },
    onInput(val) {
      this.search = val;
      this.open = true;
      this.$emit('search', val);
    },
    close() {
      this.open = false;
    },
    onScroll(e) {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        this.$emit('load-more');
      }
    },
    selectOption(value, label) {
      this.$emit('select', { value, label });
      this.open = false;
      this.search = '';
    },
  },
};
</script>

<style scoped>
.ew-client-select__input {
  padding-left: 2rem;
}

.ew-client-select__search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.85rem;
  pointer-events: none;
}

.ew-client-select__caret,
.ew-client-select__spinner {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.8rem;
  pointer-events: none;
}

.ew-client-select__list {
  z-index: 1000;
  max-height: 240px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/ClientSelect.vue